import { Dialog } from '@cimplico/components';
import { toastNotification } from '../../../components/toast/Toast';
import { useUpdateFileRecords } from '../../../queries/use-update-file-records';
import { FileRecordNew, FileStatusEnum } from '../../../types/file-record';

type DocumentClearCheckOutConfirmProps = {
    fileRecords: FileRecordNew[];
    onClose: () => void;
};

function DocumentClearCheckOutConfirm({ fileRecords, onClose }: DocumentClearCheckOutConfirmProps): JSX.Element {
    const updateRecordsQuery = useUpdateFileRecords();

    function checkIn(): void {
        updateRecordsQuery.mutate(
            fileRecords.map((record) => ({ id: record.id, fields: { status: FileStatusEnum.CHECKED_IN }, updateReferences: true })),
            {
                onSuccess: () => {
                    onClose();
                    toastNotification('success', 'Document marked as checked in!');
                },
            }
        );
    }

    const message =
        fileRecords.length === 1
            ? `Do you want to mark ${fileRecords[0].name} as checked in? All references will also be checked-in.`
            : `Do you want to mark ${fileRecords.length} documents as checked in? All references will also be checked-in.`;

    return (
        <Dialog
            type="info"
            primaryAction="Check In"
            secondaryAction="Cancel"
            description={message}
            title="Mark as Checked In"
            isOpen={true}
            onClose={onClose}
            onSecondaryActionClick={onClose}
            onPrimaryActionClick={checkIn}
            isLoading={updateRecordsQuery.isLoading}
        />
    );
}
export default DocumentClearCheckOutConfirm;
